import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface SetupSectionProps {
  title?: string;
  description?: string;
  children?: ReactNode;
}

const SetupSection = ({ title, description, children }: SetupSectionProps) => (
  <Stack spacing={2} p={4}>
    <Box>
      {title && <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{title}</Typography>}
      {description && <Typography variant="body2" color="text.secondary">{description}</Typography>}
    </Box>
    {children}
  </Stack>
);

export default SetupSection;
